import cn from 'classnames'
import { Tile } from '@mc/design-system'
import { paths } from '@mc/paths'

import type { CourseMeta } from 'types/data'
import Image from 'components/LegacyImage'
import Link from 'components/Link/CustomLink'
import { trackInstructorTileClicked } from 'components/GlobalCarousel'

import styles from './InstructorTile.module.scss'

export type Pill = {
  text: string
  link: string
}

type InstructorTileProps = {
  courseMeta: CourseMeta
  colIdx: number
  categoryName: string
  subcatName?: string
  pills: Pill[]
}

export const InstructorTile = ({
  courseMeta,
  colIdx,
  categoryName,
  subcatName,
  pills,
}: InstructorTileProps) => (
  <div className={styles.tile}>
    <Link
      ariaHidden
      href={paths.courseTypePage(courseMeta.contentType, courseMeta.courseSlug)}
      tabIndex={-1}
      onClick={() =>
        trackInstructorTileClicked({
          colIdx,
          tileClass: courseMeta.courseSlug,
          categoryName,
          subcatName,
        })
      }
      passHref
      className='mc-mt-3'
    >
      <Tile aspectRatio='auto' className={styles.tileContent}>
        <Image
          objectFit='cover'
          src={courseMeta.instructorImgSrc}
          alt=''
          className='mc-corners--3'
          layout='fill'
        />
      </Tile>

      <div className={cn('mc-mt-3 mc-mb-4', styles.instructorInfo)}>
        <p className='mc-text-h6 mc-text--2-lines'>
          {courseMeta.instructorName}
        </p>
        <p className='mc-text-x-small mc-opacity--hinted mc-text--3-lines'>
          {courseMeta.instructorBio}
        </p>
      </div>
    </Link>
    <div className='d-flex flex-wrap'>
      {pills.map((pill, idx) => (
        <p
          className={cn(
            'mc-text-h8 mc-bg-container-tint-dark mc-mt-2',
            styles.outcomePill,
          )}
          key={idx}
        >
          <Link href={pill.link}>{pill.text}</Link>
        </p>
      ))}
    </div>
  </div>
)
